import component from "./AllAroundResults";

export default component;
